import { createApi } from '@reduxjs/toolkit/query/react';
import { fronteggBaseQuery } from '../../fronteggBaseQuery';
import type { IRole } from '../types';

export const fronteggRolesApi = createApi({
  baseQuery: fronteggBaseQuery(),
  reducerPath: 'fronteggRoles',
  tagTypes: ['Roles'],
  endpoints: (builder) => ({
    getRoles: builder.query<IRole[], void>({
      query: () => ({
        url: 'identity/resources/roles/v1',
        method: 'GET',
      }),
    }),
  }),
});

export const {
  endpoints: { getRoles },
  useGetRolesQuery,
} = fronteggRolesApi;
